import cn from 'classnames';
import { FC, useId, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useIsOverflowing } from '@/shared/hooks';

import styles from './FieldInstruction.module.scss';

type Props = {
  instruction: string;
  className?: string;
};

export const FieldInstruction: FC<Props> = ({ instruction, className }) => {
  const textId = useId();
  const [expanded, setExpanded] = useState(false);
  const text = instruction.trim();
  const { isOverflowing, ref } = useIsOverflowing<HTMLParagraphElement>(text);

  if (!text) {
    return (
      <p
        data-component="workspace-field-instruction"
        className={cn('p2', styles.empty, className)}
      >
        <FormattedMessage
          id="workspace.preview.noInstruction"
          defaultMessage="No AI instruction: AI fills this field from its name alone."
        />
      </p>
    );
  }

  return (
    <div
      data-component="workspace-field-instruction"
      className={cn(styles.root, className)}
    >
      <p
        ref={ref}
        id={textId}
        className={cn('p2', styles.text, !expanded && styles.collapsed)}
      >
        {text}
      </p>
      {(expanded || isOverflowing) && (
        <button
          type="button"
          aria-expanded={expanded}
          aria-controls={textId}
          className={cn('p4', styles.toggle)}
          onClick={() => setExpanded((current) => !current)}
        >
          {expanded ? (
            <FormattedMessage
              id="workspace.preview.showLess"
              defaultMessage="Show less"
            />
          ) : (
            <FormattedMessage
              id="workspace.preview.showMore"
              defaultMessage="Show more"
            />
          )}
        </button>
      )}
    </div>
  );
};
